import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/page-image/swyy/分析仪.png';
const _hoisted_1 = {
  class: "swyy-wrapper"
};
const _hoisted_2 = {
  class: "swyy-page"
};
const _hoisted_3 = {
  class: "content-wrapper"
};
const _hoisted_4 = {
  class: "right-content"
};
const _hoisted_5 = {
  class: "section"
};
const _hoisted_6 = {
  class: "section"
};
export default /*@__PURE__*/_defineComponent({
  __name: 'Swyy',
  setup(__props) {
    // 组件已通过unplugin-vue-components自动注册为全局组件，无需手动导入
    return (_ctx, _cache) => {
      const _component_Breadcrumb = _resolveComponent("Breadcrumb");
      const _component_SideMenu = _resolveComponent("SideMenu");
      const _component_SectionTitle = _resolveComponent("SectionTitle");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Breadcrumb, {
        items: [{
          label: '首页',
          path: '/'
        }, {
          label: '产品服务'
        }, {
          label: '生物医药'
        }]
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SideMenu, {
        activeId: "swyy"
      }), _createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "page-title"
      }, "多模态分析仪", -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "publish-time"
      }, "发布时间：2025年1月1日", -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "product-image"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "多模态分析仪"
      })], -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_SectionTitle, {
        title: "产品介绍"
      }), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "intro-content"
      }, [_createElementVNode("p", null, "本设备是显微成像与光谱技术相结合的分析检测仪,主要用于药物分子鉴定、半导体表面缺陷分析、晶圆应力分布、药物污染物源、组织病理切片诊断、病原微生物鉴定、病原菌药物敏感度测试、环境微生物鉴定等领域。")], -1))]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_SectionTitle, {
        title: "主要参数"
      }), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "params-content"
      }, [_createElementVNode("div", {
        class: "params-title"
      }, "产品特点"), _createElementVNode("div", {
        class: "params-list"
      }, [_createElementVNode("p", null, "显微成像系统最高分辨率达200nm"), _createElementVNode("p", null, "拉曼光谱检测的空间分辨率达到200nm，可绘制成分生成分布热图"), _createElementVNode("p", null, "可用于微生物样品等极弱信号的检测"), _createElementVNode("p", null, "光谱分辨率≤5cm-1"), _createElementVNode("p", null, "采用多重校准流程,标准样品谱峰重复性±0.1cm-1")])], -1))])])])]), _createVNode(_component_Footer)]);
    };
  }
});